export default __webpack_public_path__ + "static/media/likert-face-2.3b5ea4d5.svg";